import { Flex } from "@capioweb/ui-components/src"
import { BlockCommonLayout } from "../../utils/layout"

const CapioJobylonBlock: React.FC = (props) => {
	const jobylonScript = `<div id="jobylon-jobs-widget"></div>
                            <script type="text/javascript">
                                /*** CONFIGURATION ***/
                                var jbl_group_id = 98;
                                var jbl_version = 'v2';
                                var jbl_page_size = 10;
                                /*** DON'T EDIT BELOW THIS LINE ***/
                                (function() {
                                var el = document.createElement('script');
                                el.src = 'https://cdn.jobylon.com/embedder.js';
                                el.type = 'text/javascript';
                                el.async = true;
                                d = (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]);
                                d.appendChild(el);
                                })();
                            </script>`

	return (
		<BlockCommonLayout>
			<Flex w={1} minh={{ _: "70vh", m: 125 }}>
				<iframe srcDoc={jobylonScript} width="100%" height="100%"></iframe>
			</Flex>
		</BlockCommonLayout>
	)
}

export { CapioJobylonBlock }
